// extracted by mini-css-extract-plugin
export default {"innerWrapper":"mu-z","tooltipWrapper":"nu-z","icon":"ou-z","tooltip":"pu-z","content":"qu-z"};